import { BasicQuestion } from "../../models";
import { ProductSharedSettingsBuilder } from "../builders";
import { ProductType } from "../enums";

/**
 * Product shared settings
 * *Manages settings shared by all [Product];
 */
export class ProductSharedSettings {
  public readonly isActive: boolean;
  public readonly name: string;
  public readonly type: ProductType;
  public readonly description: string;
  public readonly instructions: string;
  public readonly warning: string;
  public readonly questions: BasicQuestion[];
  public readonly serviceFee?: number;
  public readonly isFeePercentage: boolean;
  public readonly tips?: number[];
  public readonly isPrivate: boolean;
  public readonly appLink: string;
  public readonly redirect: boolean;
  public readonly redirectUrl: string;

  /**
   * Creates an instance of product shared settings.
   * @param builder
   */
  constructor(builder: ProductSharedSettingsBuilder) {
    this.isActive = builder.isActive;
    this.isPrivate = builder.isPrivate;
    this.appLink = builder.appLink;
    this.redirect = builder.redirect;
    this.redirectUrl = builder.redirectUrl;
    this.name = builder.name;
    this.type = builder.type;
    this.description = builder.description;
    this.instructions = builder.instructions;
    this.warning = builder.warning;
    this.questions = builder.questions;
    this.isFeePercentage = builder.isFeePercentage;
    this.serviceFee = builder.serviceFee;
    this.tips = builder.tips;
  }

  toJSON = () => ({
    isActive: this.isActive ? this.isActive : false,
    appLink: this.appLink === "" ? undefined : this.appLink,
    isPrivate: this.isPrivate ?? false,
    name: this.name ? this.name : null,
    type: this.type != null ? this.type : null,
    description: this.description ? this.description : null,
    instructions: this.instructions ? this.instructions : null,
    warning: this.warning ? this.warning : null,
    isFeePercentage: this.isFeePercentage,
    questions: this.questions
      ? this.questions.map(question => question.toJSON())
      : null,
    serviceFee:
      this.serviceFee != null
        ? this.isFeePercentage
          ? this.serviceFee
          : this.serviceFee * 100
        : null,
    tips: this.tips ? this.tips.map(tip => tip * 100) : null,
    redirectUrl: this.redirectUrl ?? "",
    redirect: this.redirect ?? false
  });
}
